.buttonText {
  max-width: 80%;
}

.formHelperText {
  margin-top: 0;
}

.inputLabel {
  position: static;
  top: initial;
  left: initial;
  color: #757575;
  transform: none;
}

.title {
  font-weight: 500;
  font-size: 0.875rem;
  text-transform: uppercase;
}

